import React from 'react';
import { t } from 'helpers/componentHelper';

import './LockPickTM.scss';

function LockPickTM() {
  return (
    <span className={'lock-pick-tm'} title={`${t('app.lockPick.titleDesc')}`}>
      LOCK PICK &#8482;
    </span>
  );
}

export default LockPickTM;
